export default "__VITE_ASSET__CoTbtimc__"